"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCodeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M23.71 22.71l-1.42-1.42 5.3-5.29-5.3-5.29 1.42-1.42 6.7 6.71-6.7 6.71zM8.29 22.71L1.59 16l6.7-6.71 1.42 1.42L4.41 16l5.3 5.29-1.42 1.42zM12.032 26.74l6-21.996 1.93.526-6 21.997z" })));
}
exports.default = SvgCodeOutline;
//# sourceMappingURL=CodeOutline.js.map